<template>
  <div class="row">
    <div class="col-md-12">
      <div class="dash-inner-box">
        <div class="dashboard-heading mb-0">
          <h1>College Highlights</h1>
        </div>
        <form>
        <div class="info-table">
          <ul>
            <li>
              <div class="row">
                <div class="col-md-6">
                  <div class="row rowFlex">
                    <div class="col-md-4 border-right">
                      Established In
                    </div>
                    <div class="col-md-8">
                      <input type="text" id="establish" name="established_in" class="info-input saveInfo"
                             v-bind:value="`${highlights.established_in != null ? highlights.established_in : ''}`" @blur="saveData($event)"/>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row rowFlex">
                    <div class="col-md-4 border-right">
                      University Type
                    </div>
                    <div class="col-md-8">
                      <input type="text" id="university_type" name="university_type" class="info-input"
                             v-bind:value="`${highlights.university_type != null ? highlights.university_type : ''}`" @blur="saveData($event)"/>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="row">
                <div class="col-md-6">
                  <div class="row rowFlex">
                <div class="col-md-4 border-right">
                  Accredited to
                </div>
                <div class="col-md-8">
                  <input type="text" id="accredited" name="accredited_to" class="info-input"
                         v-bind:value="`${highlights.accredited_to != null ? highlights.accredited_to : ''}`" @blur="saveData($event)"/>
                </div>
              </div>
                </div>
                <div class="col-md-6">
                  <div class="row rowFlex">
                    <div class="col-md-4 border-right">
                      Entrance Exam
                    </div>
                    <div class="col-md-8">
                      <input type="text" id="entrance" name="entrance_exam" class="info-input"
                             v-bind:value="`${highlights.entrance_exam != null ? highlights.entrance_exam : ''}`" @blur="saveData($event)"/>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="row">
                <div class="col-md-6">
                  <div class="row rowFlex">
                <div class="col-md-4 border-right">
                  Total Number Of Courses
                </div>
                <div class="col-md-8">
                  <input type="text" id="programs" name="total_programs" class="info-input"
                         v-bind:value="`${highlights.total_programs != null ? highlights.total_programs : ''}`" @blur="saveData($event)"/>
                </div>
              </div>
                </div>
                <div class="col-md-6">
                  <div class="row rowFlex">
                    <div class="col-md-4 border-right">
                      Popular Courses
                    </div>
                    <div class="col-md-8">
                      <input type="text" id="popular" name="popular_course" class="info-input"
                             v-bind:value="`${highlights.popular_course != null ? highlights.popular_course : ''}`" @blur="saveData($event)"/>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="row">
                <div class="col-md-6">
                  <div class="row rowFlex">
                <div class="col-md-4 border-right">
                  Application Mode
                </div>
                <div class="col-md-8">
                  <select class="info-input" name="application_mode" @blur="saveData($event)"
                          v-bind:value="`${highlights.application_mode != null ? highlights.application_mode : 'both'}`">
                    <option value="both">Online and Offline Mode</option>
                    <option value="offline">Offline</option>
                    <option value="online">Online</option>
                  </select>
                </div>
              </div>
                </div>
                <div class="col-md-6">
                  <div class="row rowFlex">
                    <div class="col-md-4 border-right">
                      Average Fees
                    </div>
                    <div class="col-md-8">
                      <input type="text" id="fees" name="fees" class="info-input"
                             v-bind:value="`${highlights.fees != null ? highlights.fees : ''}`" @blur="saveData($event)"/>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="row">
                <div class="col-md-6">
              <div class="row rowFlex">
                <div class="col-md-4 border-right">
                  Top Recruiters
                </div>
                <div class="col-md-8">
                  <input type="text" id="recruiters" name="top_recruiter" class="info-input"
                         v-bind:value="`${highlights.top_recruiter != null ? highlights.top_recruiter : ''}`" @blur="saveData($event)"/>
                </div>
              </div>
                </div>
                <div class="col-md-6">
                  <div class="row rowFlex">
                    <div class="col-md-4 border-right">
                      Brochure Link
                    </div>
                    <div class="col-md-8">
                      <input type="text" id="brochure" name="brochure" class="info-input"
                             v-bind:value="`${highlights.brochure != null ? highlights.brochure : ''}`" @blur="saveData($event)"/>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </form>
        </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {requestHeaders} from "../../_helpers/apiHelper";
import toastr from "../../../public/js/toastr";

export default {
  name: "Highlights",
  data(){
    return{
      highlights: [],
    }
  },
  mounted() {
    this.getHighlights();
  },
  methods:{
    getHighlights(){
      let self = this;
      axios.post(`${this.$parent.url}api/v2/college-profile/get-info`, '', {headers: requestHeaders()}).then(
          function (response){
            if(response['data']['response']['status'] == 200){
              self.highlights = response['data']['response']['org_info'];
            }
          }
      )
    },
    saveAbout(event){
      let self = this;
      let clickedElem = event.currentTarget;
      let parElme = clickedElem.parentElement;
      let inputElem = parElme.querySelector('.aboutText');
      let data = {[inputElem.getAttribute('name')]: inputElem.value};
      self.$parent.notchLoading = 'collegeDes'
      self.saveInfoApiCall(data);

    },
    saveInfoApiCall(data){
      let self = this;
      axios.post(`${this.$parent.url}api/v2/college-profile/save-info`, data, {headers: requestHeaders()}).then(
          function (response) {
            if (response.status == 200) {
              self.$parent.notchLoading = null
            } else {
              self.$parent.notchLoading = null
              toastr.error('Some error occurred. Try again later', 'Oops!!');
            }
          }
      )
    },
    saveData(event) {
      let self = this;
      let inputElem = event.target;
      let inputVal = inputElem.value;
      let inputName = inputElem.getAttribute('name');
      let data = {[inputName]: inputVal};
      self.saveInfoApiCall(data);
    },
  }
}
</script>

<style scoped>

</style>